import React, { useRef, useState } from 'react'
import { Dropdown, Modal, message, Input, InputRef } from 'antd'
import { IconMoreHorizontal, Edit, Delete } from 'wujieai-react-icon'
import styles from './HistoryActions.module.css'
import classNames from 'classnames'
import {
  getConversationList_openAiQuery_pageConversation_edges_node,
  deleteConversation,
  deleteConversationVariables,
  updateConversation,
  updateConversationVariables,
} from '~/graphqls/types'
import { DELETE_CONVERSATION, UPDATE_CONVERSATION } from '~/graphqls/gqls/gpt'
import { useMutation } from '@apollo/client'
import { graphQLErrorMessage } from '~/utils'

interface IProps {
  className?: string
  getContainer?: () => HTMLElement
  item?: getConversationList_openAiQuery_pageConversation_edges_node
  onEdit: (
    item?: getConversationList_openAiQuery_pageConversation_edges_node
  ) => void
  onDeleteOk?: (
    item?: getConversationList_openAiQuery_pageConversation_edges_node
  ) => void
  onEditOk?: () => void
  collapsed?: boolean
}
const actions: any[] = [
  {
    key: 'edit',
    icon: <Edit size={16} />,
    label: '重命名',
  },
  {
    key: 'delete',
    icon: <Delete size={16} className="text-[#EF466F]" />,
    label: '删除',
  },
]
const HistoryActions: React.FC<IProps> & {
  Editor: typeof Editor
} = ({ className, item, onDeleteOk, onEditOk, onEdit, collapsed }) => {
  const [visible, setVisible] = useState(false)

  const [deleteConversationAction] = useMutation<
    deleteConversation,
    deleteConversationVariables
  >(DELETE_CONVERSATION)

  const handleDelete = async (
    item?: getConversationList_openAiQuery_pageConversation_edges_node
  ) => {
    Modal.confirm({
      title: '提示',
      className: `hookModal dark`,
      maskStyle: {
        backgroundColor: 'rgba(0,0,0,0.8)',
      },
      content: (
        <div className={classNames('text-sm text-center text-neutral-800')}>
          删除后，该对话将不可恢复。
          <br />
          确认删除吗?
        </div>
      ),
      centered: true,
      okText: '确认',
      onOk: async () => {
        try {
          const res = await deleteConversationAction({
            variables: { id: item?.id },
          })
          if (res.data?.openAiMutation?.status) {
            onDeleteOk?.(item)
            message.destroy()
            message.success('删除成功')
          } else {
            throw Error('删除失败')
          }
        } catch (error) {
          message.destroy()
          message.error(graphQLErrorMessage(error) || '删除失败')
        }
      },
    })
  }

  return (
    <>
      <Dropdown
        menu={{
          items: actions,
          onClick: node => {
            if (node.key === 'delete') {
              handleDelete(item)
            } else if (node.key === 'edit') {
              onEdit(item)
            }
          },
        }}
        placement="bottomRight"
        arrow={false}
        trigger={['click']}
        overlayClassName={styles.dropDownWrap}
      >
        <div className={styles.dropDownTrigger}>
          <IconMoreHorizontal
            onClick={e => {
              if (collapsed) {
                e.stopPropagation()
              }
              setVisible(!visible)
            }}
            className={classNames(
              'rotate-90 text-neutral-400 hover:text-neutral-500',
              className
            )}
            size={16}
          />
        </div>
      </Dropdown>
    </>
  )
}
const Editor: React.FC<{
  editItem?: getConversationList_openAiQuery_pageConversation_edges_node
  setEditItem: React.Dispatch<
    React.SetStateAction<
      getConversationList_openAiQuery_pageConversation_edges_node | undefined
    >
  >
  onEditOk?: (
    item?: getConversationList_openAiQuery_pageConversation_edges_node
  ) => void
}> = ({ editItem, setEditItem, onEditOk }) => {
  const [title, setTitle] = useState(editItem?.title || '')
  const inputRef = useRef<InputRef>(null)

  const [updateConversationAction] = useMutation<
    updateConversation,
    updateConversationVariables
  >(UPDATE_CONVERSATION)

  const onUpdate = async () => {
    try {
      if (!title || title === editItem?.title) {
        setEditItem(undefined)
        return
      }
      if (title.length > 20) {
        message.destroy()
        message.error('标题不能超过20个字符')
        setEditItem(undefined)
        return
      }

      const res = await updateConversationAction({
        variables: {
          input: {
            id: editItem?.id,
            title,
          },
        },
      })
      if (res.data?.openAiMutation?.updateConversation) {
        if (editItem) {
          editItem.title = title
        }

        message.destroy()
        message.success('编辑成功')
        onEditOk?.(editItem)
        setEditItem(undefined)
      } else {
        throw Error('编辑失败')
      }
    } catch (error) {
      message.destroy()
      message.error(graphQLErrorMessage(error) || '编辑失败')
    }
  }

  return (
    <Input
      ref={inputRef}
      placeholder="请输入"
      autoFocus
      value={title}
      onChange={e => {
        setTitle(e.target.value)
      }}
      onFocus={() => {}}
      onBlur={onUpdate}
      className="!rounded-lg h-10 p-2"
      maxLength={20}
      onPressEnter={() => {
        inputRef.current?.blur()
      }}
    />
  )
}
HistoryActions.Editor = Editor
export default HistoryActions
